import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import Link from "@shared/components/contents/link/Link";
import Icon from "@shared/components/Icon";
import React from "react";
const ContactBlock = (props) => {
    const { id, title, subtitle, link, ...others } = props;
    return (_jsxs(Stack, { direction: { xs: "column", sm: "row" }, spacing: 3, sx: {
            position: "relative",
            width: "100%",
            padding: { xs: "32px 36px", sm: "66.5px 72px" },
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "background.main",
        }, ...others, children: [_jsx(Box, { sx: {
                    display: "contents",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        backgroundImage: "url('/pattern-contact-left.svg')",
                        backgroundPosition: "left",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        inset: 0,
                        display: { xs: "none", sm: "block" },
                    },
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        backgroundImage: "url('/pattern-contact-right.svg')",
                        backgroundPosition: "right",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        display: { xs: "none", md: "block" },
                        inset: 0,
                    },
                } }), _jsxs(Stack, { spacing: 3, sx: { zIndex: 1 }, children: [title && (_jsx(Typography, { variant: "h4", component: "h2", sx: { color: "primary.contrastText" }, children: title })), subtitle && (_jsx(Typography, { variant: "subtitle2", component: "p", sx: { color: "primary.contrastText" }, children: subtitle }))] }), _jsx(Box, { children: link && (link.page || link.url) && (_jsx(Button, { variant: "outlined", endIcon: _jsx(Icon, { icon: "arrow-right" }), component: Link, ...link, sx: {
                        color: "primary.contrastText",
                        backgroundColor: "background.main",
                        borderColor: "primary.contrastText",
                        "&:hover": {
                            backgroundColor: "background.main",
                        },
                    }, children: link.title })) })] }));
};
export default ContactBlock;
